<div class="centered-content">
    <i class="pi pi-info-circle" style="font-size: 5rem;"></i>
    <h5>You are not a registered vendor </h5>
</div>